import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Scrollt beim Route-Wechsel nach oben.
 *
 * Anforderungen:
 * - Nur bei "normalen" Navigationen (PUSH/REPLACE), nicht bei Browser Back/Forward (POP)
 * - Hash-Navigation (/#section) soll nicht kaputt gemacht werden
 */
export default function ScrollToTop() {
    const location = useLocation();
    const navigationType = useNavigationType(); // POP | PUSH | REPLACE

    useEffect(() => {
        // Bei Back/Forward (POP) Scrollposition behalten.
        if (navigationType === 'POP') return;

        // Wenn ein Hash gesetzt ist, überlassen wir dem Browser das Scrollen zum Anchor.
        if (location.hash) return;

        try {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        } catch (e) {
            // Fallback für sehr alte Browser / edge cases
            window.scrollTo(0, 0);
        }
    }, [location.pathname, location.search, location.hash, navigationType]);

    return null;
}

